import * as React from 'react';
import { AxiosResponse } from 'axios';
import { connect } from 'react-redux';

import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import NotifyHOC from '../../HOC/Notifications';
import * as projectService from '../../services/project.service';
import * as Action from '../../actions/project.actions';
import { Project } from '@nexxt/common/types';
import { splitPathname } from '../../utils/string';
import { alertMessage } from '../../constants/alertMessage';
import Loader from '../common/Loader/Loader';

const mapStateToProps = (store) => {
    const {
        projectReducer: { projects, newProject, botSettings },
        router: { location }
    } = store;
    return {
        projects,
        newProject,
        location,
        botSettings
    };
};

const mapDispatchToProps = (dispatch) => ({
    setBotSettings: (botSettings: Project) => {
        dispatch(Action.setBotSettings(botSettings));
    },
    setProject: (project: any) => {
        dispatch(Action.setProject(project));
    }
});

interface IProjectHOCProps {
    newProject: any;
    location: any;
    botSettings: any;
    toastNotification: any;

    setBotSettings: (botSettings: Project) => Promise<any>;
    setProject: (project: Project) => Promise<any>;
}

const ProjectHOC = (WrappedComponent) => {
    class HOC extends React.Component<IProjectHOCProps, any> {
        tenantId = null;
        constructor(props) {
            super(props);
            this.tenantId = tokenService.getTenantId();
            this.state = {
                isLoading: true
            };
        }

        componentDidMount() {
            const tenantId = this.tenantId;
            const projectId = splitPathname(this.props.location.pathname);
            if (
                Object.keys(this.props.newProject).length === 0 ||
                this.props.newProject.id !== +projectId
            ) {
                this.fetchProjectById(tenantId, projectId);
            } else {
                this.setState({
                    isLoading: false
                });
            }
        }

        fetchProjectById = async (tenantId, projectId) => {
            try {
                this.setState({
                    isLoading: true
                });
                const response: AxiosResponse =
                    await projectService.fetchProject(projectId);

                const projectDetails = response.data.data;
                const data = {
                    ...projectDetails,
                    name: projectDetails.name,
                    selectedLanguage: projectDetails.languages,
                    selectedClient: projectDetails.client,
                    tenantID: this.tenantId,
                    projectId,
                    packageID: response.data.packageID,
                    previousPackage: response.data.previousPackage,
                    previewDate: response.data.previewDate
                };

                this.props.setProject(data);
                this.setState({
                    isLoading: false
                });
            } catch (error) {
                this.props.setProject(null);
                this.setState({
                    isLoading: false,
                    error: true
                });
                this.props.toastNotification.error(
                    alertMessage.UNABLE_FETCH_PROJECT
                );
            }
        };

        render() {
            const projectId = splitPathname(this.props.location.pathname);
            if (this.state.isLoading) return <Loader isFixed />;
            return (
                <WrappedComponent
                    key={projectId}
                    {...this.props}
                    isLoading={this.state.isLoading}
                    error={this.state.error}
                    location={this.props.location}
                />
            );
        }
    }

    return NotifyHOC(connect(mapStateToProps, mapDispatchToProps)(HOC));
};

export default ProjectHOC;
